import { useEffect, useState } from "react";
import { Search, X } from "lucide-react";
import api from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { FileText, PlayCircle, Image as ImageIcon } from "lucide-react";

export default function MediaPicker({ onSelect, type = "image", label = "Kütüphaneden Seç", testid = "media-picker" }) {
  const [open, setOpen] = useState(false);
  const [files, setFiles] = useState([]);
  const [q, setQ] = useState("");
  const [page, setPage] = useState(0);
  const PAGE_SIZE = 12;
  const pageCount = Math.max(1, Math.ceil(files.length / PAGE_SIZE));
  const pageFiles = files.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);

  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => {
      api.get(`/admin/media?type=${type}${q ? `&q=${encodeURIComponent(q)}` : ""}`)
        .then(({ data }) => setFiles(data.files))
        .catch(() => {});
    }, 250);
    return () => clearTimeout(t);
  }, [open, q, type]);

  return (
    <>
      <button type="button" data-testid={`${testid}-open`} onClick={() => setOpen(true)} className="flex items-center gap-2 bg-white border border-stone-300 hover:border-forest text-stone-700 text-xs font-semibold px-4 py-2.5 rounded-lg transition-colors whitespace-nowrap">
        <ImageIcon className="w-4 h-4" /> {label}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-white max-w-3xl">
          <DialogHeader><DialogTitle>Ortam Kütüphanesi</DialogTitle></DialogHeader>
          <div className="relative">
            <input data-testid={`${testid}-search`} value={q} onChange={(e) => { setQ(e.target.value); setPage(0); }} placeholder="Dosya ara..." className="w-full h-11 pl-10 pr-4 rounded-xl border border-stone-300 text-sm focus:outline-none focus:ring-2 focus:ring-forest/30" />
            <Search className="w-4 h-4 text-stone-400 absolute left-3.5 top-3.5" />
          </div>
          <div className="grid grid-cols-3 sm:grid-cols-4 gap-3 max-h-96 overflow-y-auto mt-2">
            {pageFiles.map((f) => (
              <button key={f.file_id} type="button" data-testid={`${testid}-file-${f.file_id}`} onClick={() => { onSelect(f.url); setOpen(false); }} style={{ aspectRatio: "1 / 1" }} className="group relative w-full rounded-xl overflow-hidden border-2 border-transparent hover:border-forest transition-colors bg-cream-dark flex items-center justify-center">
                {f.type === "image" ? <img src={f.url} alt={f.original_filename} loading="lazy" className="absolute inset-0 w-full h-full object-cover" /> : f.type === "video" ? <PlayCircle className="w-8 h-8 text-stone-400" /> : <FileText className="w-8 h-8 text-stone-400" />}
                <span className="absolute inset-x-0 bottom-0 bg-black/60 text-white text-[10px] px-1.5 py-1 truncate opacity-0 group-hover:opacity-100 transition-opacity">{f.original_filename}</span>
              </button>
            ))}
            {files.length === 0 && <p className="col-span-4 text-center text-sm text-stone-400 py-10">Dosya bulunamadı</p>}
          </div>
          {files.length > PAGE_SIZE && (
            <div className="flex items-center justify-between mt-3 pt-3 border-t border-stone-100">
              <button type="button" data-testid={`${testid}-prev`} onClick={() => setPage((p) => Math.max(0, p - 1))} disabled={page === 0} className="text-xs font-semibold text-forest disabled:text-stone-300 px-3 py-1.5 rounded-lg hover:bg-stone-50 transition-colors">← Önceki</button>
              <span data-testid={`${testid}-page-info`} className="text-xs text-stone-500">Sayfa {page + 1} / {pageCount} • {files.length} dosya</span>
              <button type="button" data-testid={`${testid}-next`} onClick={() => setPage((p) => Math.min(pageCount - 1, p + 1))} disabled={page >= pageCount - 1} className="text-xs font-semibold text-forest disabled:text-stone-300 px-3 py-1.5 rounded-lg hover:bg-stone-50 transition-colors">Sonraki →</button>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
